// noinspection Stylelint

import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {white, darkGray, seaNavy, airBlue} from '@modifi/colors'
import {Container, media as _media, ButtonLink, Col} from '@modifi/ui'

import Picture from '../../ui/cms-picture'
import Video from '../../ui/cms-video'
import TopFoldWrapper from './TopFoldWrapper'
import {hexToRgba} from '../common'

type mediaType = Record<string, any>

const media = _media as mediaType

type WrapperType = {
  inverseFontColor?: boolean
  shortHeroImage?: boolean
}

export const StyledButtonLink = styled(ButtonLink)`
  color: ${white};
`

export const Wrapper = styled(TopFoldWrapper)<WrapperType>`
  position: relative;
  color: ${({inverseFontColor}): string => (inverseFontColor ? white : darkGray)};
  ${({shortHeroImage}): FlattenSimpleInterpolation | string =>
    shortHeroImage
      ? css`
          min-height: 50vh;
        `
      : ''}

  p,
  h1 {
    color: ${({inverseFontColor}): string => (inverseFontColor ? white : darkGray)};
  }
`

type BackgroundPictureType = {
  objectFit: string
}

export const BackgroundPicture = styled.div<BackgroundPictureType>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -20;

  > img {
    object-fit: ${({objectFit}): string => objectFit};
    object-position: 20% center;
    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
    font-family: 'object-fit: ${({objectFit}): string => objectFit}; object-position: 70% center;';
    ${media.md`
      object-position: center center;
      font-family: 'object-fit: ${({objectFit}: {objectFit: string}): string =>
        objectFit}; object-position: center center;';
    `}
  }
`

export const Inner = styled.div`
  height: 100%;
`

export const BackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const gradientStart = hexToRgba(airBlue, 0.2)
const gradientEnd = hexToRgba(seaNavy, 0.8)

export const Gradient = styled.div`
  background-image: linear-gradient(2deg, ${gradientStart} 2%, ${gradientEnd} 98%);
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -10;
`

export const StyledVideo = styled(Video)`
  object-fit: cover;
  height: 100%;
  z-index: -20;
`

export const StyledPicture = styled(Picture)`
  z-index: -20;
`

export const StyledContainer = styled(Container)`
  position: relative;
  height: 100%;
  z-index: 10;
`

const shortHeroImageStyles = css`
  ${media.xs`
    margin-top: 40px;
    margin-bottom: 70px;
  `}
  ${media.md`
    h1 {
      font-size: 48px;
      line-height: 59px;
    }
  `}
`

type MainContentWrapperProps = {
  shortHeroImage?: boolean
}

export const MainContentWrapper = styled.div<MainContentWrapperProps>`
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${media.sm`
    height: 88%;
  `}
  margin-top: 40px;
  margin-bottom: 40px;
  ${({shortHeroImage}): any => (shortHeroImage ? shortHeroImageStyles : '')}
`

export const BottomCtaWrapper = styled.div`
  position: absolute;
  bottom: 24px;
  width: 100%;
`

export const StyledCol = styled(Col)`
  padding: 0;
`
